import { render, staticRenderFns } from "./PendingPayments.vue?vue&type=template&id=5860659f&scoped=true&"
import script from "./PendingPayments.vue?vue&type=script&lang=ts&"
export * from "./PendingPayments.vue?vue&type=script&lang=ts&"
import style0 from "./PendingPayments.vue?vue&type=style&index=0&id=5860659f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5860659f",
  null
  
)

export default component.exports